import Vue from "vue";

["stripMessage", "badwords"].forEach((e) => {
  Vue.filter(e, require(`./${e}.js`).default);
});
